import { ControlledDocumentPreviewPageController } from './controlled-document-preview-page.controller';
import { ControlledDocumentPreviewPageProps } from './controlled-document-preview-page.model';

export const ControlledDocumentPreviewPage = (
  props: ControlledDocumentPreviewPageProps
) => {
  return <ControlledDocumentPreviewPageController {...props} />;
};
